/*
 *
 *  * (C) Copyright 2006-2020 hSenid Mobile Solutions (Pvt) Limited.
 *  *
 *  * All Rights Reserved.
 *  *
 *  * These materials are unpublished, proprietary, confidential source code of
 *  * hSenid Mobile Solutions (Pvt) Limited and constitute a TRADE SECRET
 *  * of hSenid Mobile Solutions (Pvt) Limited.
 *  *
 *  * hSenid Mobile Solutions (Pvt) Limited retains all title to and intellectual
 *  * property rights in these materials.
 *  *
 *
 */

import React, { useLayoutEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { Waypoint } from "react-waypoint";
import {
  AppsByClassificationPageEvent,
  useAppsByClassificationPageDataSelector,
} from ".";
import ErrorPage from "../ErrorPage";
import SecondHeader from "../../Common/SecondHeader";
import AppGutter from "../../Common/AppGutter";
import * as configData from "../../../config.json";
import { LoadingStatus } from "../../../rootReducer/actions";
import { CLASSIFICATION } from "../../../constants";

interface AppsByClassificationPageProps {
  mainHeading: string;
  classification: string;
}

export default function AppsByClassificationPage({
  mainHeading,
  classification,
}: AppsByClassificationPageProps) {
  const dispatch = useDispatch();
  const [currentPage, setCurrentPage] = useState<number>(1);
  const pageData = useAppsByClassificationPageDataSelector();

  useLayoutEffect(() => {
    setCurrentPage(1);
    dispatch({
      type: AppsByClassificationPageEvent.GET_APPS_BY_CLASSIFICATION_PAGE_DATA,
      payload: {
        specification: classification,
        pageNo: 1,
        pageSize: configData.APPS_PER_PAGE,
      },
    });
    return () => {
      dispatch({
        type: AppsByClassificationPageEvent.RESET,
      });
    };
  }, [classification]);

  const onCallBack = (args: Waypoint.CallbackArgs) => {
    if (currentPage < pageData?.totalPages) {
      dispatch({
        type: AppsByClassificationPageEvent.GET_APPS_BY_CLASSIFICATION_PAGE_DATA,
        payload: {
          specification: classification,
          pageNo: currentPage + 1,
          pageSize: configData.APPS_PER_PAGE,
        },
      });
      setCurrentPage(currentPage + 1);
    }
    return;
  };

  return (
    <>
      <SecondHeader key="normal" />
      {pageData.loadingStatus === LoadingStatus.LOADING_ERROR ? (
        <ErrorPage />
      ) : (
        <div className="container">
          <AppGutter
            pageData={pageData}
            mainHeading={mainHeading}
            subHeading={configData.SUB_TITLES.APPS}
            note={
              classification === CLASSIFICATION.NEWLY_ADDED
                ? configData.INTRO.NEW
                : classification === CLASSIFICATION.TOP_RATED
                ? configData.INTRO.TOP_RATED
                : configData.INTRO.MOST_USED
            }
          />
          {pageData.apps.length !== 0 &&
            pageData.apps.length < pageData.totalElements && (
              <Waypoint onEnter={onCallBack} scrollableAncestor={window} />
            )}
        </div>
      )}
    </>
  );
}
